<template>
  <div>
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="selected_assess=='管理成熟度测评'">管理成熟度测评</el-breadcrumb-item>
            <el-breadcrumb-item v-if="selected_assess=='组织健康度测评'">组织健康度测评</el-breadcrumb-item>
        </el-breadcrumb> -->
        <!-- <div style="width:100%;height:42.67px;margin-bottom:25px;">
            <div class="select_area">
                <span>请选择查询的测评：</span>
                <el-select v-model="selected_assess" placeholder="请选择">
                    <el-option
                    v-for="item in assess_list"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </div>
        </div> -->
        <div style="width:100%;height:40px;margin-bottom:10px;">
            <div class="top_buttons" style="float:left;">
                <el-button icon="el-icon-download" type="primary" @click="export_results">导出原始评分结果</el-button>
                <el-button icon="el-icon-download" type="primary" @click="export_results_details">导出计算后得分结果</el-button>
                <el-button icon="el-icon-refresh" type="primary" @click="refresh_results">刷新结果</el-button>
                <el-button icon="el-icon-download" type="warning" @click="export_summary">导出解读报告数据</el-button>
                <!-- <el-dialog title="导出结果" :visible.sync="dialogFormVisible" width="400px" :destroy-on-close="true" :close-on-click-modal="false">
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="选择公司">
                            <el-select v-model="form.selected_company" placeholder="请选择">
                                <el-option
                                v-for="item in form.company_list"
                                :key="item"
                                :label="item"
                                :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <div style="margin-top:20px;">
                            <el-button @click="cancle_export">取 消</el-button>
                            <el-button type="primary" @click="export_results">确 定</el-button>
                        </div>
                    </el-form>
                </el-dialog> -->
            </div>
            <div class="search" style="float:right;">
                <el-form :inline="true" :model="formInline" @submit.native.prevent>
                <el-form-item>
                <el-input
                placeholder="请输入搜索信息"
                v-model="formInline.search_info"
                @keyup.native.enter="search"
                clearable>
                </el-input>
                </el-form-item>
                <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                </el-form-item>
                </el-form>
            </div>
        </div>
        <div style="margin-bottom:10px;">
            <el-alert
                :title="tips"
                type="warning"
                show-icon>
            </el-alert>
        </div>
        <!-- 通过key来检测路由的变化，使用query方式的路由跳转，路由地址会发生变化 -->
        <!-- <router-view :key="this.$route.fullPath"></router-view> -->
        <cheng-shu ref="chengshu_ref" :query_info="formInline.search_info" :task_id="task_id">
            <!-- <p>这里父组件替换的内容</p> -->
            <!-- <template v-slot:title="pageinfo">
                <p>子组件中pageinfo参数的count信息：{{ pageinfo.count }}</p>
            </template>
            <template v-slot:default="pageinfo">
                <p>子组件中pageinfo参数的count信息：{{ pageinfo.count + 1 }}</p>
            </template> -->
        </cheng-shu>
        <!-- <jian-kang v-if="this.selected_assess=='组织健康度测评'" ref="jiankang_ref"></jian-kang> -->
  </div>
</template>

<script>
import chengShu from "./ChengShu_MyTakePartIn.vue";
// import jianKang from "./JianKang_MyTakePartIn.vue";
import getdata from "@/api/getData.js";
import postdata from "@/api/postData.js";
export default {
    components: {
        chengShu,
        // jianKang,
    },
    created() {
        getdata.getList("checklogin")
              .then(() => {
                
              })
              .catch(() => {
                if(localStorage.getItem("token") != null){
                    this.$message({
                        message: '会话超时，请重新登录！',
                        type: 'warning',
                    })
                }
                this.$router.push({
                    path: '/login',
                });
              })
    },
    data() {
        return {
            // selected_assess: '管理成熟度测评',
            // assess_list: ['管理成熟度测评', '组织健康度测评'],
            formInline: {
                search_info: '',
                search_result: [],
            },
            tips: '可单击“刷新结果”按钮刷新后台结果数据。',
            mana_template_file: {
                file_name: 'Assessment_results.xlsx',
                
            },
            results_details_file: {
                file_name: 'Assessment_results_details.xlsx',
            },
            summary_file: {
                file_name: 'Basic_data_for_report.xlsx'
            },
            form: {
                company_list: [],
                selected_company: '',
            },            
            dialogFormVisible: false,
        };
    },
    props: ['task_id'],
    methods: {
        search() {
            this.$refs.chengshu_ref.get_results(this.formInline.search_info);
        },
        refresh_results() {
            // if(this.selected_assess=='管理成熟度测评'){
            this.$refs.chengshu_ref.refresh_results();
            // }
        },
        cancle_export() {
            this.dialogFormVisible = false;
        },
        export_results_by_users() {
            // 先从后台获取公司列表
            getdata.getList("getCompanyList")
                .then(resp => {
                    if(resp.data.code == 200){
                        this.form.company_list = resp.data.data;
                        this.form.selected_company = this.form.company_list[0];
                        // 获取到公司列表后，打开导出页面
                        this.dialogFormVisible = true;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        export_results() {
            // if(this.selected_assess=='管理成熟度测评'){
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP("exportResultsByUsers", JSON.stringify(this.mana_template_file), params)
            .then(resp => {
                // this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
            })
            .catch(err => {
                console.log(err);
            })
            // }
        },
        export_results_details() {
            let params;
            params = {
                task_id: this.task_id,
            }
            // 使用新的接口，增加数据的自动计算
            postdata.downloadFilesP("exportResultsDetailsWithAutoCalc", JSON.stringify(this.results_details_file), params)
            .then(resp => {               
                // this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        export_summary() {
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP("exportBasicData", JSON.stringify(this.summary_file), params)
            .then(resp => {               
                // this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
            },
    }
};
</script>

<style scoped>
/* .el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
} */
.top_buttons > .el-button {
    font-size: 16px;
    /* font-weight: bold; */
}
/* ::v-deep .el-form-item {
    margin-bottom: 0;
}
::v-deep .el-table__header {
    font-size: 16px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
} */
.select_area {
    text-align: left;
    float: left;
}
.select_area ::v-deep .el-input {
    font-size: 16px;
}
.select_area ::v-deep .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
}
.search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
}
::v-deep .el-alert__title {
    font-size: 16px;
}
::v-deep .el-alert__content {
    text-align: left;
}
::v-deep .el-form-item {
    margin-bottom: 0;
}
::v-deep .el-dialog__header {
    text-align: left;
}
</style>